import { EntApi } from "../EntApi";
import { LicenseWithCredits } from "../../model/entitlement/LicenseWithCredits";
import { LicenseUsage } from "../../model/entitlement/LicenseUsage";
import { LicenseAssignment } from "../../model/entitlement/LicenseAssignment";
import { QueryAvailableLicensesOpts } from "../../model/entitlement/QueryAvailableLicensesOpts";
import { LicenseWithOwnerAndSingleUserAssignments } from "../../model/entitlement/LicenseWithOwnerAndSingleUserAssignments";
import MockBase from "./MockBase";
import { LicenseUserWithAssignmentsAndSessions } from "../../model/entitlement/LicenseUserWithAssignmentsAndSessions";
import { LicenseAssignmentWithSessions } from "../../model/entitlement/LicenseAssignmentWithSessions";
import {
  getEnvParam,
  REACT_APP_MOCK_DATA_DELAY_MAX,
  REACT_APP_MOCK_DATA_DELAY_MIN,
} from "../../util/env";
import { sleep } from "../../util/sleep";
import apiInfo from "../../gen/api/entitlement/info.json";

const delayMin: number = parseInt(
  getEnvParam(REACT_APP_MOCK_DATA_DELAY_MIN, "0")
);
const delayMax: number = parseInt(
  getEnvParam(REACT_APP_MOCK_DATA_DELAY_MAX, "0")
);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function randomDelay() {
  const t = Math.random() * (delayMax - delayMin) + delayMin;
  if (t) {
    await sleep(t);
  }
  return;
}

class MockEnt extends MockBase implements EntApi {
  getApiInfo(): Promise<{ version: string; [key: string]: any }> {
    return new Promise((resolve) => {
      resolve(apiInfo);
    });
  }
  public async queryAvailableLicenses(
      userId: string,
      queryAvailableLicensesOpts?: QueryAvailableLicensesOpts
  ): Promise<LicenseWithOwnerAndSingleUserAssignments[]> {

    throw new Error(`Todo: create some sort of mock`);
  }

  private getOrgLicenseUsageByLicenseId(
      orgLicenses: LicenseWithCredits[],
      licenseUsersByLicenseId: {
        [licenseId: string]: LicenseUserWithAssignmentsAndSessions[];
      },
      licenseId: string
  ): LicenseUsage | undefined {
    const license = orgLicenses.find((lic) => lic.id === licenseId);
    if (license === undefined) {
      return;
    }

    const licenseUsers = licenseUsersByLicenseId[license.id as string];

    return {...license, users: licenseUsers};
  }

  private getLicenseAssignmentsInternal(
      licenses: LicenseWithCredits[],
      licenseUsersByLicenseId: {
        [licenseId: string]: LicenseUserWithAssignmentsAndSessions[];
      },
      licenseId: string,
      userId: string
  ): LicenseAssignment[] {
    // Yet another curveball: all of these are in fact correctly typed, copied in from orgadmin and working. Here, for some reason the compiler
    // insists these are implicit any, even though the return types of these functions are clearly not any.
    const licenseUsage = this.getOrgLicenseUsageByLicenseId(
        licenses,
        licenseUsersByLicenseId,
        licenseId
    );
    this.undefinedTo404(licenseUsage);
    if (licenseUsage && licenseUsage.users && licenseUsage.users.length) {
      return licenseUsage.users
          .filter(
              (licenseUser) => licenseUser?.id === userId && licenseUser.assignments
          )
          .flatMap(
              (licenseUser) =>
                  licenseUser.assignments as LicenseAssignmentWithSessions
          )
          .map((assignmentWithSessions) => {
            const {sessions: _, ...other} = assignmentWithSessions;
            return other;
          });
    }
    return [];
  }

}
export default MockEnt;
